export default __webpack_public_path__ + "static/media/capture-stones.22ced2b8.yaml";